import ListingImage from '@Components/Listings/ListingImage';

const PhotoListing_AdvancedPhotoThumb = (props) => {
    return (
        <a href={props.DestinationUrl} className='thumb advanced-photo-thumb'>
            <ListingImage IsAT={props.IsAT} IsEF={props.IsEF} LinkTarget={props.LinkTarget}
                LazyLoad ListingTitle={props.Title} AbsolutePathBaseUrl={props.AbsolutePathBaseUrl}
                {...props.ListingImageModel} />
            <div className='thumb-details'>
                {props.Title && <div className='title'>{props.Title}</div>}
                {props.Description && <div className='desc'>{props.Description}</div>}
            </div>
        </a>
    );
};

export default PhotoListing_AdvancedPhotoThumb;